import Marionette from "../../../shared/marionette-mustache";
import { LegislationRelationModel } from "../../../desktop/models/legislation-relation";
import { backboneViewProperties } from "../../../decorators/backbone-properties";

const template = require<string>("../../../desktop/views/partials/amending-item-relation.html");

@backboneViewProperties({
    tagName: "div",
    template
})
export class AmendingItemRelationView extends Marionette.ItemView<LegislationRelationModel> {
    constructor(options?: Backbone.ViewOptions<LegislationRelationModel>) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/partials/amending-item-relation.ts